import React, { useEffect } from 'react';
import Header from './header';
import Footer from './footer';

function AboutUs() {
    useEffect(() => {
        window.scrollTo(0, 0);
        
        // Set page title and meta tags
        document.title = "About SR PAY - India's Leading Fintech Platform | Digital Payments";
        
        // Update meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', 'SR PAY Private Limited is India\'s leading fintech platform providing digital banking, bill payments, recharges, and financial services through a network of 10L+ retailers across India.');
        
        // Update meta keywords
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
            metaKeywords = document.createElement('meta');
            metaKeywords.setAttribute('name', 'keywords');
            document.head.appendChild(metaKeywords);
        }
        metaKeywords.setAttribute('content', 'about SR PAY, fintech company India, digital payments platform, banking services, bill payments, money transfer, AEPS, BBPS, mobile recharge');
        
        // Update OG tags
        updateMetaTag('og:title', 'About SR PAY - India\'s Leading Fintech Platform');
        updateMetaTag('og:description', 'SR PAY provides digital banking, bill payments, and financial services to 10L+ retailers across India.');
        updateMetaTag('og:type', 'website');
        
        // Canonical link
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', 'https://www.srpay1.com/aboutus');
        
    }, []);

    const updateMetaTag = (property, content) => {
        let meta = document.querySelector(`meta[property="${property}"]`);
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('property', property);
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', content);
    };

    return (
        <div className="modern-app">
            <Header />
            
            {/* Page Title Banner */}
            <section style={{ 
                background: 'linear-gradient(135deg, #C9262C 0%, #FF8C00 50%, #FFDD09 100%)',
                padding: '80px 0 60px',
                marginTop: '60px',
                textAlign: 'center'
            }}>
                <div className="container">
                    <h1 style={{ 
                        fontSize: '3rem', 
                        fontWeight: 800, 
                        color: 'white', 
                        marginBottom: '10px',
                        letterSpacing: '-0.5px'
                    }}>
                        About <span style={{ color: '#FFDD09' }}>SR PAY</span>
                    </h1>
                    <p style={{ 
                        color: 'rgba(255,255,255,0.95)', 
                        fontSize: '1.2rem',
                        maxWidth: '700px',
                        margin: '0 auto'
                    }}>
                        Empowering India's Digital Financial Revolution
                    </p>
                </div>
            </section>

            {/* Main Content */}
            <section style={{ padding: '60px 0', background: '#FAFBFC' }}>
                <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
                    
                    {/* Mission Section */}
                    <div style={{ 
                        background: 'white', 
                        borderRadius: '20px', 
                        padding: '40px', 
                        marginBottom: '30px', 
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                        border: '1px solid #E5E7EB'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                            <span style={{ fontSize: '32px' }}>🎯</span>
                            <h2 style={{ 
                                color: '#1A1A2E', 
                                fontWeight: 700, 
                                fontSize: '1.8rem',
                                margin: 0
                            }}>
                                Our Mission
                            </h2>
                        </div>
                        <p style={{ color: '#4A4A6A', lineHeight: 1.9, fontSize: '1.05rem', margin: 0 }}>
                            At <strong>SR PAY Private Limited</strong>, our mission is to bridge the digital divide between urban and rural India by providing accessible, secure, and instant financial services to every citizen. We believe that everyone deserves access to basic banking and financial services at their nearest point possible. In this era of technology, many rural areas are still underserved, and we are committed to providing a digital bridge between Rural & Urban India.
                        </p>
                    </div>

                    {/* Who We Are */}
                    <div style={{ 
                        background: 'white', 
                        borderRadius: '20px', 
                        padding: '40px', 
                        marginBottom: '30px', 
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                        border: '1px solid #E5E7EB'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                            <span style={{ fontSize: '32px' }}>🏢</span>
                            <h2 style={{ 
                                color: '#1A1A2E', 
                                fontWeight: 700, 
                                fontSize: '1.8rem',
                                margin: 0
                            }}>
                                Who We Are
                            </h2>
                        </div>
                        <p style={{ color: '#4A4A6A', lineHeight: 1.9, fontSize: '1.05rem', marginBottom: '20px' }}>
                            We are <strong>SR PAY Private Limited</strong> - a leading fintech company committed to excellence and innovation. With a passion to prosper, we bring you the best Fintech Service & Utility Payment platform. Created with dedication and cutting-edge technology, we empower our distributors & retailers to cater to the banking and daily financial needs of the general public in India.
                        </p>
                        <p style={{ color: '#4A4A6A', lineHeight: 1.9, fontSize: '1.05rem', margin: 0 }}>
                            Through unrivaled technology, we enable any local store to function as a Digital Fintech & Utility Service Centre. Our platform offers innovative banking solutions including <strong>Cash Deposit, Cash Withdrawal, Balance Inquiry, Bill Payments, UPI, Bharat QR, Aadhaar Enabled Services, Mobile & DTH Recharge, POS Services, Railway Ticketing</strong>, and more through our authorized agents across India.
                        </p>
                    </div>

                    {/* Our Vision */}
                    <div style={{ 
                        background: 'white', 
                        borderRadius: '20px', 
                        padding: '40px', 
                        marginBottom: '30px', 
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                        border: '1px solid #E5E7EB'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                            <span style={{ fontSize: '32px' }}>👁️</span>
                            <h2 style={{ 
                                color: '#1A1A2E', 
                                fontWeight: 700, 
                                fontSize: '1.8rem',
                                margin: 0
                            }}>
                                Our Vision
                            </h2>
                        </div>
                        <p style={{ color: '#4A4A6A', lineHeight: 1.9, fontSize: '1.05rem', marginBottom: '20px' }}>
                            To be the <strong>leader in the fintech revolution</strong> and be at the forefront of India's technological transformation. We aim to establish ourselves as a key player in online fintech services while generating sustainable profits for our associates.
                        </p>
                        <p style={{ color: '#4A4A6A', lineHeight: 1.9, fontSize: '1.05rem', margin: 0 }}>
                            With the <strong>best possible commission offers</strong> and dedicated agent care network, we strive to bring world-class services to merchants at the lowest cost possible in the furthermost corners of this vast country. Our goal is to always give class-leading services and keep improving ourselves to provide a customer-enriching experience.
                        </p>
                    </div>

                    {/* Key Stats */}
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                        gap: '20px', 
                        marginBottom: '30px' 
                    }}>
                        {[
                            { number: '10,00,000+', label: 'Active Partners', icon: '🤝' },
                            { number: '28,000+', label: 'Pin Codes Covered', icon: '📍' },
                            { number: '₹500 Cr+', label: 'Monthly Transactions', icon: '💸' },
                            { number: '99.9%', label: 'Uptime Guarantee', icon: '✅' }
                        ].map((stat, index) => (
                            <div key={index} style={{ 
                                background: 'white', 
                                borderRadius: '16px', 
                                padding: '30px 20px', 
                                textAlign: 'center', 
                                boxShadow: '0 4px 20px rgba(0,0,0,0.06)', 
                                border: '1px solid #E5E7EB',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(201,38,44,0.15)';
                                e.currentTarget.style.borderColor = '#FFDD09';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)';
                                e.currentTarget.style.borderColor = '#E5E7EB';
                            }}>
                                <div style={{ fontSize: '36px', marginBottom: '10px' }}>{stat.icon}</div>
                                <div style={{ 
                                    fontSize: '2rem', 
                                    fontWeight: 800, 
                                    background: 'linear-gradient(135deg, #C9262C, #FF8C00)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    marginBottom: '8px'
                                }}>
                                    {stat.number}
                                </div>
                                <div style={{ color: '#4A4A6A', fontWeight: 600 }}>{stat.label}</div>
                            </div>
                        ))}
                    </div>

                    {/* Our Commitment */}
                    <div style={{ 
                        background: 'white', 
                        borderRadius: '20px', 
                        padding: '40px', 
                        marginBottom: '30px', 
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                        border: '1px solid #E5E7EB'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                            <span style={{ fontSize: '32px' }}>💪</span>
                            <h2 style={{ 
                                color: '#1A1A2E', 
                                fontWeight: 700, 
                                fontSize: '1.8rem',
                                margin: 0
                            }}>
                                Our Commitment
                            </h2>
                        </div>
                        <p style={{ color: '#4A4A6A', lineHeight: 1.9, fontSize: '1.05rem', marginBottom: '20px' }}>
                            Our team works <strong>tirelessly 24/7</strong> to integrate and provide best-in-class services. We continuously add new services and improve our platform to ensure the best user experience. Our employees are trained to handle the most difficult situations with ease and maintain timely commitment to our partners.
                        </p>
                        <p style={{ color: '#4A4A6A', lineHeight: 1.9, fontSize: '1.05rem', margin: 0 }}>
                            Our entire focus is on delivering <strong>class-leading services</strong> and constantly improving ourselves to provide a customer-enriching experience. We are working wholeheartedly towards achieving our goal of being at the forefront of India's fintech revolution.
                        </p>
                    </div>

                    {/* CTA Section */}
                    <div style={{ 
                        background: 'linear-gradient(135deg, #C9262C 0%, #FF8C00 50%, #FFDD09 100%)',
                        borderRadius: '20px',
                        padding: '50px 40px',
                        textAlign: 'center',
                        color: 'white'
                    }}>
                        <h2 style={{ 
                            fontSize: '2rem', 
                            fontWeight: 800, 
                            marginBottom: '15px',
                            color: 'white'
                        }}>
                            Ready to Join the Fintech Revolution?
                        </h2>
                        <p style={{ 
                            fontSize: '1.1rem', 
                            marginBottom: '30px',
                            color: 'rgba(255,255,255,0.9)',
                            maxWidth: '500px',
                            margin: '0 auto 30px'
                        }}>
                            Become a part of India's fastest-growing fintech network and start earning today!
                        </p>
                        <a 
                            href="/joinus" 
                            style={{
                                display: 'inline-block',
                                padding: '16px 40px',
                                background: 'white',
                                color: '#C9262C',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                fontWeight: 700,
                                fontSize: '1.1rem',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.transform = 'translateY(-3px)';
                                e.target.style.boxShadow = '0 15px 35px rgba(0,0,0,0.3)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.2)';
                            }}
                        >
                            Join SR PAY Today →
                        </a>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default AboutUs;